// resources/js/core/props.ts
// Boundary-safe decoding of element data-* props. Optionally plug per-component validators.
import type { WidgetKey } from '@/types/core';

export type Validator = (u: unknown) => unknown; // may throw; returns typed value

export type Validators = Readonly<Record<WidgetKey, Validator>>;

export function decode(raw: string | null): unknown {
    if (!raw) return {};
    try {
        return JSON.parse(raw);
    } catch {
        return {};
    }
}
export function validateFor(key: WidgetKey, input: unknown, validators?: Validators): unknown {
    const v = validators?.[key];
    if (!v) return input;
    try {
        return v(input);
    } catch (e) {
        return {};
    }
}
